/* Americanflat search overlay. Triggered by any [data-af-search-trigger].
   Hits Shopify's /search/suggest.json for live results. Closes on scrim/Esc.

   SIZE MATCHING (rewritten 2026-09-09)
   The previous version tested `size.startsWith(wholeQuery)`, which could only
   ever match when the query was a prefix of a size — so "16" matched but
   "16x20 black frame" returned nothing, including for three of the trending
   pills this overlay suggests itself. It also ran `.replace(/x/g,'×')` across
   the whole query, corrupting any word containing an x ("box" -> "bo×").

   Now: dimensions are parsed OUT of the query as tokens and matched against the
   store's real size collections (rendered into [data-af-size-map] by
   af-search-overlay.liquid), and a matched size links to that collection rather
   than re-running the same search. */
(function () {
  const root = document.getElementById('AfSearchOverlay');
  if (!root) return;
  const scrim = root.querySelector('[data-af-search-scrim]');
  const panel = root.querySelector('[data-af-search-panel]');
  const input = root.querySelector('[data-af-search-input]');
  const closeBtn = root.querySelector('[data-af-search-close]');
  const content = root.querySelector('[data-af-search-content]');
  const sizesEl = root.querySelector('[data-af-sizes]');
  const sizesLabel = root.querySelector('[data-af-sizes-label]');
  const trendingWrap = root.querySelector('[data-af-trending]');
  const categoriesEl = root.querySelector('[data-af-categories]');
  const productsEl = root.querySelector('[data-af-products]');
  const cols = {
    sizes: root.querySelector('[data-af-col="sizes"]'),
    categories: root.querySelector('[data-af-col="categories"]'),
    products: root.querySelector('[data-af-col="products"]'),
  };

  /* { "16×20": "16x20-picture-frames", … } — every size that has a collection. */
  let SIZE_MAP = {};
  try { SIZE_MAP = JSON.parse(root.dataset.afSizeMap || '{}'); } catch (e) { SIZE_MAP = {}; }
  const SIZE_KEYS = Object.keys(SIZE_MAP);

  const POPULAR_SIZES = ['8×10', '11×14', '16×20', '5×7', '4×6', '18×24', '24×36'];

  function moneyFmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  }
  function highlight(text, query) {
    if (!query) return escapeHtml(text);
    const lower = text.toLowerCase();
    const idx = lower.indexOf(query.toLowerCase());
    if (idx < 0) return escapeHtml(text);
    return escapeHtml(text.slice(0, idx)) +
      '<mark>' + escapeHtml(text.slice(idx, idx + query.length)) + '</mark>' +
      escapeHtml(text.slice(idx + query.length));
  }

  /* Turn "16x20" into "16×20" ONLY between two digits, so ordinary words that
     contain an x are left alone. */
  function normalizeDims(s) {
    return s.replace(/(\d)\s*[x×]\s*(\d)/gi, '$1×$2');
  }

  function sizeUrl(size) {
    const handle = SIZE_MAP[size];
    return handle ? '/collections/' + handle : '/search?q=' + encodeURIComponent(size);
  }

  /* Sizes relevant to a query, most specific first. Returns [] when the query
     says nothing about size — the column is then hidden rather than showing an
     empty-state message. */
  function sizesFor(query) {
    const q = normalizeDims(query.trim().toLowerCase());

    // 1. Explicit dimensions anywhere in the query: "16x20 black frame".
    const dims = q.match(/\d+(?:\.\d+)?×\d+(?:\.\d+)?/g) || [];
    if (dims.length) {
      const stocked = dims.filter((d) => SIZE_MAP[d]);
      if (stocked.length) return stocked.slice(0, 8);
      // Dimension typed but not carried — offer the same width in other heights.
      const width = dims[0].split('×')[0];
      return SIZE_KEYS.filter((k) => k.split('×')[0] === width).slice(0, 8);
    }

    // 2. A bare number: "16" -> 16×16, 16×20, 16×24.
    if (/^\d+(?:\.\d+)?$/.test(q)) {
      return SIZE_KEYS.filter((k) => k.split('×')[0].startsWith(q)).slice(0, 8);
    }

    return [];
  }

  /* Hide columns with nothing in them and retitle the grid so the remaining
     ones fill the row instead of leaving holes. */
  function setVisibleCols(state) {
    let n = 0;
    Object.keys(cols).forEach((k) => {
      if (!cols[k]) return;
      cols[k].hidden = !state[k];
      if (state[k]) n++;
    });
    if (content) content.setAttribute('data-cols', String(n));
  }

  function open() {
    scrim.classList.add('open');
    panel.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input.focus(), 120);
    renderEmpty();
  }
  function close() {
    scrim.classList.remove('open');
    panel.classList.remove('open');
    document.body.style.overflow = '';
    input.value = '';
  }

  scrim.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.classList.contains('open')) close();
  });

  document.querySelectorAll('[data-af-search-trigger]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });
  });

  function renderEmpty() {
    sizesLabel.textContent = 'Popular sizes';
    sizesEl.className = 'af-search-pillrow';
    sizesEl.innerHTML = POPULAR_SIZES.map((s) => (
      '<a href="' + sizeUrl(s) + '">' + s + '</a>'
    )).join('');
    trendingWrap.style.display = '';
    categoriesEl.innerHTML = '<li class="af-search-empty">Start typing to see categories.</li>';
    productsEl.innerHTML = '<li class="af-search-empty">Start typing to see products.</li>';
    setVisibleCols({ sizes: true, categories: true, products: true });
  }

  function renderResults(query, data) {
    const q = query.trim();
    trendingWrap.style.display = 'none';

    // Always rewrite each group, so a hidden column never keeps the previous
    // query's results sitting in the DOM.
    const matched = sizesFor(q);
    sizesLabel.textContent = matched.length === 1 ? 'Matching size' : 'Matching sizes';
    sizesEl.className = matched.length ? 'af-search-pillrow' : '';
    sizesEl.innerHTML = matched.map((s) => (
      '<a href="' + sizeUrl(s) + '">' + s + '</a>'
    )).join('');

    const colls = (data && data.resources && data.resources.results && data.resources.results.collections) || [];
    categoriesEl.innerHTML = '';
    if (colls.length) {
      categoriesEl.innerHTML = colls.slice(0, 5).map((c) => (
        '<li><a class="af-search-sugg" href="' + c.url + '">' +
          '<span>' + highlight(c.title, q) + '</span>' +
          '<span class="kind">Collection</span>' +
        '</a></li>'
      )).join('');
    }

    const prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    productsEl.innerHTML = '';
    if (prods.length) {
      productsEl.innerHTML = prods.slice(0, 6).map((p) => {
        const img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        const price = (typeof p.price === 'number') ? moneyFmt(p.price * 100) : (p.price || '');
        return (
          '<li><a class="af-search-prod" href="' + p.url + '">' +
            '<div class="thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div><h5>' + highlight(p.title, q) + '</h5><div class="meta">' + escapeHtml(p.vendor || p.product_type || '') + '</div></div>' +
            '<div class="price">' + price + '</div>' +
          '</a></li>'
        );
      }).join('');
    }

    setVisibleCols({ sizes: matched.length > 0, categories: colls.length > 0, products: prods.length > 0 });

    // Nothing anywhere — one clear message beats three empty columns.
    if (!matched.length && !colls.length && !prods.length) {
      sizesLabel.textContent = 'No results';
      sizesEl.className = '';
      sizesEl.innerHTML =
        '<li class="af-search-empty">Nothing matched &ldquo;' + escapeHtml(q) + '&rdquo;. ' +
        'Try a size like 11&times;14, a collection, or a frame name.</li>';
      setVisibleCols({ sizes: true, categories: false, products: false });
    }
  }

  let timer = null;
  let abortCtrl = null;
  input.addEventListener('input', () => {
    const q = input.value.trim();
    if (timer) clearTimeout(timer);
    if (!q) {
      renderEmpty();
      return;
    }
    timer = setTimeout(() => {
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: abortCtrl.signal })
        .then((r) => r.json())
        .then((data) => renderResults(q, data))
        .catch((err) => { if (err.name !== 'AbortError') console.error(err); });
    }, 180);
  });

  root.querySelectorAll('[data-af-pill]').forEach((p) => {
    p.addEventListener('click', () => {
      input.value = p.textContent;
      input.dispatchEvent(new Event('input'));
    });
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && input.value.trim()) {
      window.location.href = '/search?q=' + encodeURIComponent(input.value.trim());
    }
  });
})();
